import React from "react" ;
import { IonGrid, IonRow, IonCol, IonButton } from '@ionic/react';

const NavigationButton = () => {
    return (
        <>
             <IonGrid>
                <IonRow>
                    <IonCol className="ion-align-self-end right bottom-nav">
                        <IonButton color="primary" size="default"  mode='ios'>Next</IonButton> 
                    </IonCol>
                </IonRow>
            </IonGrid>
        </>
    )
}

export default NavigationButton;